import { For, Match, Show, Switch, createEffect, createMemo } from "solid-js";
import type { MainProps } from "./_model";
import { ExhibitionCard } from "./components";
import { solidstate } from ":setup/qstate";
import { exhibition } from "./apis";
import { Loader2 } from ":src/components/loaders";
import { createInput, createSelect } from ":ui/form";

export default function Exhibition(props: MainProps) {
  const $list = solidstate.createAsync(exhibition.get);
  const $applied_filter = solidstate.create({} as { search?: string; track?: string });
  const $filters = createMemo(() => {
    const result = {
      search: ["team_name", "track", "project_name"],
      tracks: [],
    };
    const list = $list.value;
    if (list == undefined) {
      return result;
    }
    for (const item of list) {
      if (item == undefined) {
        continue;
      }
      const track = item.track;
      if (!result.tracks.includes(track)) {
        result.tracks.push(track);
      }
    }

    return result;
  });
  const Search = createInput(null);
  const FilterTrack = createSelect(null);

  createEffect(() => {
    const search = Search.control.value;
    $applied_filter.set((s) => ({ ...s, search: search }));
  });
  createEffect(() => {
    const track = FilterTrack.control.value;
    $applied_filter.set((s) => ({ ...s, track: track }));
  });

  return (
    <section class="flex flex-col w-full min-h-full h-full px-5 py-3 gap-2 <md:(px-2 py-1)">
      <h1 class="text-xl  font-600] text-black z-1 <sm:(text-22px)">Exhibition</h1>
      <div class="flex flex-row w-full justify-between items-center gap-2 py-2 <sm:(!flex-col !gap-x-0)">
        <Search.Input autocomplete="search" class="form-input" placeholder="Search by name..." />
        <FilterTrack.Select
          class="form-select !w-30% <sm:(!w-full)"
          placeholder="Filter By Track..."
          options={$filters().tracks}
          allowClearSelected
        />
      </div>
      <Switch>
        <Match when={$list.state.loading}>
          <div class="flex w-full min-h-screen md:h-full  items-center justify-center">
            <Loader2 msg="Loading Exhibition Details..." />
          </div>
        </Match>
        <Match when={$list.state.failed}>an error occurred while fetching {$list.error}</Match>
        <Match when={$list.state.success}>
          <div class="grid grid-cols-3 gap-x-1rem w-full h-fit gap-y-4   py-2 overflow-x-hidden !overflow-y-auto scrollbar <sm:(grid-cols-1)">
            <For each={$list.value}>
              {(item) => {
                const show = createMemo(() => {
                  const search_keywords = $filters().search;
                  const search = $applied_filter?.value?.search?.toLowerCase?.();
                  const track = $applied_filter?.value?.track;
                  if (
                    search != undefined &&
                    !search_keywords.some((prop) => item[prop]?.toLowerCase().includes(search))
                  ) {
                    return false;
                  }
                  if (track != undefined && item?.track !== track) {
                    if (track === "undefined" && item.track == undefined) {
                      return true;
                    }
                    return false;
                  }

                  return true;
                });
                return (
                  <Show when={show()}>
                    <ExhibitionCard {...item} />
                  </Show>
                );
              }}
            </For>
          </div>
        </Match>
      </Switch>
    </section>
  );
}
